import React from 'react'

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell as BaseTableCell,
  TableBody
} from '@material-ui/core'
import { Text } from 'components/Typography/Basic'
import styled from 'styled-components'

const tableTitles = [
  'Category of Personal Information',
  'How we may use the Personal Information',
  'Legal Bases for processing',
  'Recipients of Personal Data'
]

const Annex2Table = () => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {tableTitles.map((tableTitle, index) => (
              <TableCell scope="col" key={index}>
                <Text
                  fontSize="2rem"
                  align="center"
                  as="h6"
                  fontWeight="900"
                  lineHeight="2.2rem"
                >
                  {tableTitle}
                </Text>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell rowSpan="2">
              <Text align="center" as="p">
                <span
                  style={{
                    fontWeight: 700
                  }}
                >
                  Approximate location information.
                </span>
                Other than information you choose to provide to us, we do not
                collect information about your precise location. Your device’s
                IP address may however help us determine an approximate
                location.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                We may use information you provide to us about your location to
                monitor and detect fraud or suspicious activity in relation to
                your W3D Domain account.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our legitimate interests, namely
                to protect our business and your account from fraud and other
                illegal activities.
              </Text>
            </TableCell>
            <TableCell rowSpan="2">
              <Text align="center" as="p">
                We may also share your personal information with:
              </Text>
              <Text as="ul">
                <li>Impact Tech, Inc.</li>
                <li>Google LLC</li>
                <li>Facebook, Inc.</li>
                <li>Mode Analytics, Inc.</li>
                <li>Tableau Software, LLC</li>
                <li>RudderStack Inc.</li>
                <li>Reddit, Inc</li>
                <li>Brave Software, Inc.</li>
                <li>Twitter, Inc.</li>
                <li>LinkedIn Coproration</li>
                <li>Microsoft Corporation</li>
                <li>Outreach Corporation</li>
                <li>Cybba, Inc.</li>
                <li>Hotjar Ltd.</li>
                <li>Optimizely, Inc.</li>
                <li>Peaberry Software, Inc.</li>
                <li>Snap, Inc.</li>
                <li>TikTok, Inc.</li>
                <li>Twitch Interactive, Inc.</li>
                <li>Unbounce Marketing Solutions, Inc.</li>
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to tailor how the European Services
                is displayed to you (such as the language in which it is
                provided to you).
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our legitimate interest, namely
                tailoring our service so that it is more relevant to our users.
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell rowSpan="3">
              <Text align="center" as="p">
                <span
                  style={{
                    fontWeight: 700
                  }}
                >
                  Information about how you access and use the European
                  Services.{' '}
                </span>
                For example, how frequently you access the European Services,
                the time you access the European Services and how long you use
                it for, the approximate location that you access the European
                Services from, the site from which you came and the site to
                which you are going when you leave our website, the website
                pages you visit, the links you click, whether you open emails or
                click the links contained in emails, whether you access the
                European Services from multiple devices, and other actions you
                take on the European Services.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                We may use information about how you use and connect to the
                European Services to present the European Services to you on
                your device.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our legitimate interests, namely
                to tailor the European Services to the user.
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to determine products and services
                that may be of interest to you for marketing purposes.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our legitimate interests, namely
                to inform our direct marketing.
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to monitor and improve the European
                Services and business, resolve issues and to inform the
                development of new products and services.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our legitimate interests, namely
                to monitor and resolve issues with the European Services and to
                improve the European Services generally.
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell rowSpan="2">
              <Text align="center" as="p">
                <span
                  style={{
                    fontWeight: 700
                  }}
                >
                  Log files and information about your device.
                </span>
                We also collect information about the tablet, smartphone or
                other electronic device you use to connect to the European
                Services. This information can include details about the type of
                device, unique device identifying numbers, operating systems,
                browsers and applications connected to the European Services
                through the device, your mobile network, your IP address and
                your device’s telephone number (if it has one).
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                We may use information about how you use and connect to the
                European Services to present the European Services to you on
                your device.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our legitimate interests, namely
                to tailor the European Services to the user.
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to monitor and improve the European
                Services and business, resolve issues and to inform the
                development of new products and services.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our legitimate interests, namely
                to monitor and resolve issues with the European Services and to
                improve the European Services generally.
              </Text>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default Annex2Table

const TableCell = styled(BaseTableCell)`
  vertical-align: text-top !important;
`
